// Type definitions for coupon assessment

// Enums for coupon assessment
export enum Destination {
  NO_URGENT_PLACE = 'No Urgent Place',
  HOME = 'Home',
  WORK = 'Work',
}

export enum Passenger {
  ALONE = 'Alone',
  FRIENDS = 'Friend(s)',
  KIDS = 'Kid(s)',
  PARTNER = 'Partner',
}

export enum Weather {
  SUNNY = 'Sunny',
  RAINY = 'Rainy',
  SNOWY = 'Snowy',
}

export enum Time {
  TWO_PM = '2PM',
  TEN_AM = '10AM',
  SIX_PM = '6PM',
  SEVEN_AM = '7AM',
  TEN_PM = '10PM',
}

export enum Coupon {
  RESTAURANT_LESS_THAN_20 = 'Restaurant(<20)',
  COFFEE_HOUSE = 'Coffee House',
  CARRY_OUT_TAKE_AWAY = 'Carry out & Take away',
  BAR = 'Bar',
  RESTAURANT_20_TO_50 = 'Restaurant(20-50)',
}

export enum Expiration {
  ONE_DAY = '1d',
  TWO_HOURS = '2h',
}

export enum Gender {
  FEMALE = 'Female',
  MALE = 'Male',
}

export enum Age {
  BELOW_21 = 'below21',
  AGE_21 = '21',
  AGE_26 = '26',
  AGE_31 = '31',
  AGE_36 = '36',
  AGE_41 = '41',
  AGE_46 = '46',
  AGE_50_PLUS = '50plus',
}

export enum MaritalStatus {
  UNMARRIED_PARTNER = 'Unmarried partner',
  SINGLE = 'Single',
  MARRIED_PARTNER = 'Married partner',
  DIVORCED = 'Divorced',
  WIDOWED = 'Widowed',
}

export enum Education {
  SOME_COLLEGE_NO_DEGREE = 'Some college - no degree',
  BACHELORS_DEGREE = 'Bachelors degree',
  ASSOCIATES_DEGREE = 'Associates degree',
  HIGH_SCHOOL_GRADUATE = 'High School Graduate',
  GRADUATE_DEGREE = 'Graduate degree (Masters or Doctorate)',
  SOME_HIGH_SCHOOL = 'Some High School',
}

export enum Occupation {
  UNEMPLOYED = 'Unemployed',
  ARCHITECTURE_ENGINEERING = 'Architecture & Engineering',
  STUDENT = 'Student',
  EDUCATION_TRAINING_LIBRARY = 'Education&Training&Library',
  HEALTHCARE_SUPPORT = 'Healthcare Support',
  HEALTHCARE_PRACTITIONERS_TECHNICAL = 'Healthcare Practitioners & Technical',
  SALES_RELATED = 'Sales & Related',
  MANAGEMENT = 'Management',
  ARTS_DESIGN_ENTERTAINMENT_SPORTS_MEDIA = 'Arts Design Entertainment Sports & Media',
  COMPUTER_MATHEMATICAL = 'Computer & Mathematical',
  LIFE_PHYSICAL_SOCIAL_SCIENCE = 'Life Physical Social Science',
  PERSONAL_CARE_SERVICE = 'Personal Care & Service',
  COMMUNITY_SOCIAL_SERVICES = 'Community & Social Services',
  OFFICE_ADMINISTRATIVE_SUPPORT = 'Office & Administrative Support',
  CONSTRUCTION_EXTRACTION = 'Construction & Extraction',
  LEGAL = 'Legal',
  RETIRED = 'Retired',
  INSTALLATION_MAINTENANCE_REPAIR = 'Installation Maintenance & Repair',
  TRANSPORTATION_MATERIAL_MOVING = 'Transportation & Material Moving',
  BUSINESS_FINANCIAL = 'Business & Financial',
  PROTECTIVE_SERVICE = 'Protective Service',
  FOOD_PREPARATION_SERVING_RELATED = 'Food Preparation & Serving Related',
  PRODUCTION_OCCUPATIONS = 'Production Occupations',
  BUILDING_GROUNDS_CLEANING_MAINTENANCE = 'Building & Grounds Cleaning & Maintenance',
  FARMING_FISHING_FORESTRY = 'Farming Fishing & Forestry',
}

export enum Income {
  LESS_THAN_12500 = 'Less than $12500',
  INCOME_12500_24999 = '$12500 - $24999',
  INCOME_25000_37499 = '$25000 - $37499',
  INCOME_37500_49999 = '$37500 - $49999',
  INCOME_50000_62499 = '$50000 - $62499',
  INCOME_62500_74999 = '$62500 - $74999',
  INCOME_75000_87499 = '$75000 - $87499',
  INCOME_87500_99999 = '$87500 - $99999',
  INCOME_100000_OR_MORE = '$100000 or More',
}

export enum Car {
  SCOOTER_MOTORCYCLE = 'Scooter and motorcycle',
  CROSSOVER = 'crossover',
  MAZDA5 = 'Mazda5',
  DO_NOT_DRIVE = 'do not drive',
  OLD_CAR = 'Car that is too old to install Onstar :D',
}

export enum FrequencyCategory {
  NEVER = 'never',
  LESS_THAN_1 = 'less1',
  ONE_TO_THREE = '1~3',
  FOUR_TO_EIGHT = '4~8',
  GREATER_THAN_8 = 'gt8',
}

export enum Temperature {
  COLD = '30',
  MILD = '55',
  HOT = '80',
}

// Interface for coupon assessment input
export interface CouponAssessmentInput {
  destination: Destination;
  passenger: Passenger;
  weather: Weather;
  temperature: Temperature;
  time: Time;
  coupon: Coupon;
  expiration: Expiration;
  gender: Gender;
  age: Age;
  maritalStatus: MaritalStatus;
  has_children: boolean;
  education: Education;
  occupation: Occupation;
  income: Income;
  car: Car;
  Bar: FrequencyCategory;
  CoffeeHouse: FrequencyCategory;
  CarryAway: FrequencyCategory;
  RestaurantLessThan20: FrequencyCategory;
  Restaurant20To50: FrequencyCategory;
  toCoupon_GEQ5min: boolean;
  toCoupon_GEQ15min: boolean;
  toCoupon_GEQ25min: boolean;
  direction_same: boolean;
  direction_opp: boolean;
}

// Interface for coupon assessment response
export interface CouponAssessmentResponse extends CouponAssessmentInput {
  will_accept_coupon: boolean;
}
